export default __webpack_public_path__ + "static/media/logo-light.327be4dd.svg";